import * as axios from 'axios'
import { setHours, setMinutes, setSeconds, addDays, isBefore } from 'date-fns'
import { homeDepotAttribution } from '@/utilities/constants'

export function getCCType (cardNameCode) {
  const cardAbrvs = {
    MC: 'Mastercard',
    DISC: 'Discover',
    AMEX: 'American Express',
    VISA: 'Visa'
  }
  if (cardAbrvs[cardNameCode]) {
    return cardAbrvs[cardNameCode]
  }

  return cardNameCode
}

export function getDNIS (utmSource, attribution) {
  if (attribution === homeDepotAttribution) {
    return 'D.com-HD-E-Commerce'
  }
  const brand = process.env.VUE_APP_BRAND
  if (utmSource === 'ppc') {
    return brand === 'DCOM' ? 'D.com-PPC-E-Commerce-completed' : `${brand}-PPC-E-Commerce-completed`
  }
  if (utmSource === 'gmb-appt') {
    return brand === 'DCOM' ? 'D.com-E-commerce-GMB' : `${brand}-E-commerce-GMB`
  }
  // if (utmSource === 'linkedin') {
  //   return brand === 'DCOM' ? 'D.com-E-commerce-Social-Linkedin' : `${brand}-E-commerce-Social-Linkedin`
  // }
  // if (utmSource === 'facebook') {
  //   return brand === 'DCOM' ? 'D.com-E-commerce-Social-Facebook' : `${brand}-E-commerce-Social-Facebook`
  // }
  return brand === 'DCOM' ? 'D.com-Ecommerce' : `${brand}-Ecommerce`
}

export function getAbandonedDNIS (utmSource, attribution) {
  if (attribution === homeDepotAttribution) {
    return 'D.com-HD-E-Commerce-Started'
  }
  const brand = process.env.VUE_APP_BRAND
  if (utmSource === 'ppc') {
    return brand === 'DCOM' ? 'D.com-PPC-E-Commerce-started' : `${brand}-PPC-E-Commerce-started`
  }
  if (utmSource === 'gmb-appt') {
    return brand === 'DCOM' ? 'D.com-E-commerce-GMB-Abandoned' : `${brand}-E-commerce-GMB-Abandoned`
  }
  // if (utmSource === 'linkedin') {
  //   return brand === 'DCOM' ? 'D.com-E-commerce-Social-Linkedin-Abandoned' : `${brand}-E-commerce-Social-Linkedin-Abandoned`
  // }
  // if (utmSource === 'facebook') {
  //   return brand === 'DCOM' ? 'D.com-E-commerce-Social-Facebook-Abandoned' : `${brand}-E-commerce-Social-Facebook-Abandoned`
  // }
  return brand === 'DCOM' ? 'D.com-E-commerce-Abandoned' : `${brand}-E-commerce-Abandoned`
}

export function isGtagReady () {
  if (window.gtag) {
    return true
  }

  return false
}

export function isGAReady () {
  if ('ga' in window && 'getAll' in window.ga && window.ga.getAll instanceof Function && window.ga.getAll().length) {
    return true
  }

  return false
}

export function isGoogleEventsReady () {
  if (isGtagReady() && isGAReady()) {
    return true
  }

  return false
}

// Make sure to check that isGoogleEventsReady() returns true before executing this function
export function getClientID () {
  const ID = window.ga.getAll()[0].get('clientId') || ''
  return `cid${ID}`
}

// Temporarily removing code to fix phone number removing last digit
export function getFormattedPhoneNumber (value) {
  const digits = value.replace(/\D/g, '').match(/(1)?(\d{0,3})(\d{0,3})(\d{0,4})/)
  const validPhoneNumber = !digits[3] ? digits[2] : '(' + digits[2] + ') ' + digits[3] + (digits[4] ? '-' + digits[4] : '')
  const phoneNumber = !digits[1] ? validPhoneNumber : digits[1] + validPhoneNumber
  return phoneNumber
}

export function getQueryString (field, url = undefined) {
  const reg = new RegExp(`[?&]${field}=([^&#]*)`, 'i')
  const result = reg.exec(url || window.location.href)
  return result ? result[1] : ''
}

export function getHolidays () {
  return axios.get('https://api.dumpsters.com/graphql?query={holidays{start}}')
    .then(response => response.data.data.holidays)
    .catch(error => {
      console.log('Failed to fetch holidays from scms api:', error)
      return []
    })
}

export function formatDate (date) {
  const d = date.split('T')[0]
  const [yyyy, mm, dd] = d.split('-')

  return new Date(yyyy, parseInt(mm, 10) - 1, dd)
}

export function formatItems (items) {
  return items.join(', ')
    .replace('_', ' ')
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
}

export function nextAvailableDate (product, holidays) {
  if (product && holidays) {
    const productDate = new Date(`${product.deliveryDate}T00:00:00`)
    const currentDate = new Date()
    currentDate.setHours(0, 0, 0, 0)
    const datesUnavailable = product.datesUnavailable.map(date => {
      return new Date(`${date}T00:00:00`)
    })

    const isDateUnavailable = () => {
      // if the delivery date is same day or lands on Saturday or Sunday
      if ((isBefore(productDate, currentDate)) || productDate.getDay() === 0 || productDate.getDay() === 6) {
        return true
      } else if (datesUnavailable.length) {
        return datesUnavailable.find(item => item.getTime() === productDate.getTime())
      } else {
        // is this date in the holiday table array
        return holidays.find(item => item.getTime() === productDate.getTime())
      }
    }

    while (isDateUnavailable()) {
      productDate.setDate(productDate.getDate() + 1)
    }

    return productDate.toLocaleDateString()
  } else {
    return ''
  }
}

// TODO: Is this really necessary
export function getNumericValue (value) {
  const match = value.match(/\d+/)
  if (match) return match[0]
  return value // If value has no digits, return it unchanged
}

// Modified from: https://stackoverflow.com/a/49620828/593230
// This function makes it so pressing enter in a provided input
// will simulate a down arrow key event before the enter key event.
// This is used to make gmaps autocomplete inputs select the first item
// when pressing enter.
export function downBeforeEnter (input) {
  /* Store original event listener */
  const _addEventListener = input.addEventListener

  const addEventListenerWrapper = (type, listener) => {
    if (type === 'keydown') {
      /* Store existing listener function */
      const _listener = listener
      listener = (event) => {
        /* Simulate a 'down arrow' keypress if no address has been selected */
        const suggestionSelected = document.getElementsByClassName('pac-item-selected').length
        if (event.key === 'Enter' && !suggestionSelected) {
          const e = new KeyboardEvent('keydown', {
            key: 'ArrowDown',
            code: 'ArrowDown',
            keyCode: 40
          })
          _listener.apply(input, [e])
        }
        _listener.apply(input, [event])
      }
    }
    _addEventListener.apply(input, [type, listener])
  }
  input.addEventListener = addEventListenerWrapper
}

export async function setupAutocomplete (autocompleteInput, placeChangedCallback) {
  downBeforeEnter(autocompleteInput)
  const options = { types: ['street_address', 'premise', 'subpremise'], componentRestrictions: { country: 'us' } }
  const autocomplete = await new google.maps.places.Autocomplete(autocompleteInput, options) //eslint-disable-line
  const addyMap = {
    street_number: 'streetAddress',
    route: 'streetName',
    locality: 'city',
    sublocality_level_1: 'city', // Ensures boroughs like Brooklyn are treated as city
    administrative_area_level_1: 'state',
    postal_code: 'postalCode',
    country: 'country'
  }
  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace()
    const coords = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    }
    if (place.address_components) {
      const address = place.address_components.reduce((accumulator, { types, short_name: shortName, long_name: longName }) => {
        if (addyMap[types[0]]) {
          accumulator[addyMap[types[0]]] = shortName || longName
        }
        return accumulator
      }, { streetAddress: '', streetName: '', state: '', postalCode: '', city: '', country: '' })
      placeChangedCallback({ ...address, ...coords })
    } else {
      placeChangedCallback(null)
    }
  })
}

// Taken from BD/DCOM utilities
export function timestamp () {
  // Get local time as ISO string with offset at the end
  const now = new Date()
  const tzo = -now.getTimezoneOffset()
  const dif = tzo >= 0 ? '+' : '-'
  const pad = function (num) {
    const norm = Math.abs(Math.floor(num))
    return (norm < 10 ? '0' : '') + norm
  }
  /* eslint-disable operator-linebreak */
  return now.getFullYear()
    + '-' + pad(now.getMonth() + 1)
    + '-' + pad(now.getDate())
    + 'T' + pad(now.getHours())
    + ':' + pad(now.getMinutes())
    + ':' + pad(now.getSeconds())
    + '.' + pad(now.getMilliseconds())
    + dif + pad(tzo / 60)
    + ':' + pad(tzo % 60)
}

export function getTimeZone (date) {
  const offset = date.getTimezoneOffset()
  const o = Math.abs(offset)
  return (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ':' + ('00' + (o % 60)).slice(-2)
}

export function googleAnalytics ({ eventCategory, eventAction, data }) {
  const time = timestamp()
  window.ga('send', {
    hitType: 'event',
    eventCategory,
    eventAction,
    eventLabel: time
  })

  window.gtag('event', eventCategory, {
    clickID: eventAction,
    timestamp: time
  })
}

// TODO: this can be removed after lightbox push
export function creditCardType (cc) {
  const amex = new RegExp('^3[47][0-9]{13}$')
  const visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$')
  const cup1 = new RegExp('^62[0-9]{14}[0-9]*$')
  const cup2 = new RegExp('^81[0-9]{14}[0-9]*$')

  const mastercard = new RegExp('^5[1-5][0-9]{14}$')
  const mastercard2 = new RegExp('^2[2-7][0-9]{14}$')

  const disco1 = new RegExp('^6011[0-9]{12}[0-9]*$')
  const disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$')
  const disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$')

  const diners = new RegExp('^3[0689][0-9]{12}[0-9]*$')
  const jcb = new RegExp('^35[0-9]{14}[0-9]*$')

  if (visa.test(cc)) {
    return 'VISA'
  }
  if (amex.test(cc)) {
    return 'AMERICAN EXPRESS'
  }
  if (mastercard.test(cc) || mastercard2.test(cc)) {
    return 'MASTERCARD'
  }
  if (disco1.test(cc) || disco2.test(cc) || disco3.test(cc)) {
    return 'DISCOVER'
  }
  if (diners.test(cc)) {
    return 'DINERS'
  }
  if (jcb.test(cc)) {
    return 'JCB'
  }
  if (cup1.test(cc) || cup2.test(cc)) {
    return 'CHINA_UNION_PAY'
  }
  return undefined
}

// Pushes object to GTM dataLayer if GTM is available
export function dataLayerPush (obj) {
  window.dataLayer && window.dataLayer.push(obj)
}

export function isMobile () {
  return window.innerWidth < 961
}

export const debrisMap = {
  constructionDebris: 'Construction Debris',
  yardOrOrganicMaterial: 'Yard or Organic Material',
  heavy: 'Heavy',
  mixedHouseholdTrash: 'Mixed Household Trash'
}

export function createSavedCartDates () {
  // lead creation date
  let createdDate = new Date()
  createdDate = setHours(createdDate, 0)
  createdDate = setMinutes(createdDate, 0)
  createdDate = setSeconds(createdDate, 0)

  // lead expiration date
  let expiresDate = new Date(createdDate)
  expiresDate = addDays(expiresDate, 13)
  expiresDate = setHours(expiresDate, 23)
  expiresDate = setMinutes(expiresDate, 59)
  expiresDate = setSeconds(expiresDate, 59)
  return {
    expiresDate,
    createdDate
  }
}

export function hubRequest (route, data, method = 'post') {
  const options = {
    method,
    url: process.env.VUE_APP_SERVER + route,
    data
  }
  if (method === 'get') { options.params = data }
  return axios(options)
    .catch(error => {
      console.log('Error on request to: ' + route, error)
      throw error
    })
}
// Freeze prevents this pseudo-enum from being modified elsewhere
export const hubRoutes = Object.freeze({
  CREATE_LEAD: '/api/salesforceLead',
  DISCOUNT_CODE: '/api/discountCode',
  UPDATE_LEAD: '/api/updateSalesforceLead'
})
// Keys are sizes we have images of, value array contains other sizes we want to map to those
export const substituteSizeMap = {
  10: [11],
  12: [13, 14],
  15: [16, 17, 18],
  20: [21, 22],
  25: [28],
  30: [35],
  40: [50, 60]
}

export function fireAddressSearchEvent (address) {
  dataLayerPush({ event: 'ecom-address-search', serviceAddress: address })
  if (isGoogleEventsReady()) {
    const time = timestamp()
    // UA
    window.gtag('event', 'Ecommerce - AddressSearch', {
      event_category: 'Ecommerce',
      event_label: `${time}~${window.location.href}~${address.streetAddress} ${address.streetName}, ${address.city}, ${address.state} ${address.postalCode}`,
      send_to: process.env.VUE_APP_UA_ID
    })

    // GA4
    window.gtag('event', 'Ecommerce - AddressSearch', {
      event_category: 'Ecommerce',
      timestamp: time,
      address: `${address.streetAddress} ${address.streetName}, ${address.city}, ${address.state} ${address.postalCode}`,
      bd_client_id: getClientID(),
      send_to: process.env.VUE_APP_GA4_ID
    })
  }
}

// Returns a validated 11-char YouTube ID, or '' if the input is not a supported URL.
function getYouTubeVideoId (value) {
  if (!value || typeof value !== 'string') return ''

  const trimmed = value.trim()
  const watchMatch = trimmed.match(/https?:\/\/(?:www\.)?youtube\.com\/watch\?v=([\w-]+)/i)
  const shortMatch = trimmed.match(/https?:\/\/youtu\.be\/([\w-]+)/i)
  const embedMatch = trimmed.match(/https?:\/\/(?:www\.)?youtube(?:-nocookie)?\.com\/embed\/([\w-]+)/i)
  const videoId = (watchMatch && watchMatch[1]) || (shortMatch && shortMatch[1]) || (embedMatch && embedMatch[1]) || ''

  return /^[\w-]{11}$/.test(videoId) ? videoId : ''
}

// Builds a trusted embed URL only. Invalid input returns '' — never raw HTML.
export function getYouTubeEmbedSrc (value) {
  const videoId = getYouTubeVideoId(value)
  if (!videoId) return ''

  return `https://www.youtube.com/embed/${videoId}?rel=0`
}

export function generateReCaptchaToken (action) {
  return new Promise((resolve, reject) => {
    // Local dev: skip Google reCAPTCHA token when env is local).
    if (process.env.VUE_APP_ENV === 'local') {
      return resolve('LOCAL_DEV_RECAPTCHA_BYPASS')
    }
    if (window.grecaptcha == null) {
      return reject(new Error('reCAPTCHA not loaded'))
    }

    if (process.env.VUE_APP_RECAPTCHA_KEY == null || process.env.VUE_APP_RECAPTCHA_KEY === '') {
      return reject(new Error('missing reCAPTCHA_KEY'))
    }

    // Insurance to make sure we don't wait for reCAPTCHA forever. 10 seconds was an arbitrary number picked.
    // The reCAPTCHA script should have been loaded on page load so at this point in the process if it's not ready
    // then it likely never will be.
    const timeoutId = setTimeout(() => {
      reject(new Error('reCAPTCHA took too long to be in a ready state'))
    }, 10000)

    window.grecaptcha.enterprise.ready(async () => {
      const token = await window.grecaptcha
        .enterprise
        .execute(process.env.VUE_APP_RECAPTCHA_KEY, { action })
      clearTimeout(timeoutId)
      resolve(token)
    })
  })
}
